export default {
  id: 24,
  title: 'Target #24 - Switches',
  url: 'https://cssbattle.dev/play/24',
  colors: ['#62306D', '#F7EC7D', '#AA445F', '#E38F66'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#62306d}a{position:fixed;width:100}a[a]{background:#aa445f;top:50}a[b]{background:#e38f66;right:80}a[a],a[b]{height:150;border-radius:50px}a[a],a[c]{left:80}a[b],a[c],a[d]{top:100}a[b],a[d]{right:80}a[c],a[d]{height:100;background:#f7ec7d;border-radius:50%}</style>',
}
